/**
 * API методы для работы с настройками доставки
 * Дата: 26.01.2026 - TODO-036
 * Связан с: internal/handler/tenant_settings.go, frontend/src/hooks/useSettings.ts, frontend/src/pages/Settings.tsx
 */
import { apiClient } from './client';

export interface FallbackRule {
  trigger: string; // "delivered_not_read", "sent_not_delivered", "failed", "action_not_completed"
  timeout_hours: number;
  next_channel: string; // "auto" или конкретный канал
  description: string;
}

export interface DeliveryPolicySettings {
  channel_priority: string[];
  disabled_channels?: string[];  // Дата: 30.01.2026 — Отключённые каналы (не участвуют в fallback)
  fallback_rules: FallbackRule[];
  max_fallback_depth: number;
  cooldown_minutes: number;
}

export interface DeliverySettings extends DeliveryPolicySettings {
  messaging_enabled?: boolean;   // Глобальный killswitch (ENV) - 26.01.2026
  broadcasts_enabled?: boolean;  // Tenant-level killswitch - 26.01.2026
  quiet_hours: QuietHoursSettings;
  broadcast_groups?: BroadcastGroupDescriptor[];
  broadcast_group_modes?: Record<string, string>;
  broadcast_group_delivery_settings?: Record<string, DeliveryPolicySettings>;
  broadcast_daily_limit?: number;
  broadcast_group_daily_limits?: Record<string, number>;
  disable_fallback_groups?: string[];
}

export interface QuietHoursSettings {
  enabled: boolean;
  start: number; // Час начала (0-23)
  end: number;   // Час конца (0-23)
}

export interface BroadcastGroupDescriptor {
  value: string;
  label: string;
}

export interface UpdateDeliverySettingsRequest {
  channel_priority?: string[];
  disabled_channels?: string[];  // Дата: 30.01.2026 — Отключённые каналы
  fallback_rules?: FallbackRule[];
  max_fallback_depth?: number;
  cooldown_minutes?: number;
  quiet_hours?: QuietHoursSettings;
  broadcast_group_modes?: Record<string, string>;
  broadcast_group_delivery_settings?: Record<string, DeliveryPolicySettings>;
  broadcast_daily_limit?: number;
  broadcast_group_daily_limits?: Record<string, number>;
  disable_fallback_groups?: string[];
}

export const settingsApi = {
  // Получить текущие delivery settings
  // SuperAdmin: передаёт tenant_id; Employee: backend берёт из context
  getDeliverySettings: async (tenantId?: string): Promise<DeliverySettings> => {
    const params: Record<string, string> = {};
    if (tenantId) {
      params.tenant_id = tenantId;
    }
    const response = await apiClient.get<DeliverySettings>('/settings/delivery', { params });
    return response.data;
  },

  // Обновить delivery settings
  updateDeliverySettings: async (
    data: UpdateDeliverySettingsRequest,
    tenantId?: string
  ): Promise<DeliverySettings> => {
    const params: Record<string, string> = {};
    if (tenantId) {
      params.tenant_id = tenantId;
    }
    const response = await apiClient.put<DeliverySettings>('/settings/delivery', data, { params });
    return response.data;
  },
};
